import bugsnag from 'bugsnag-js'

const bugsnagClient = bugsnag({
  apiKey: '3e1a3078dfd94a0e62835beb18b80df1',
  releaseStage: process.env.VUE_APP_BUGSNAG_RELEASE_STAGE,
  notifyReleaseStages: ['production', 'staging']
})
export default bugsnagClient
